// extracted by mini-css-extract-plugin
module.exports = {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__0hQ4M","player":"MediaSideBar_player__0PqW6"};